import _ from 'lodash';
import React from 'react';
import { navigateAction } from 'fluxible-router';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import { toTitleCase } from '../../lib/utils';
import InventoryRecordStore from '../../stores/InventoryRecordStore';
import Helmet from 'react-helmet';
import Breadcrumbs from '../../components/Breadcrumbs';
import { trackSearchEvent } from '../../components/InventorySearch';
import InventorySearchResults from '../../components/InventorySearchResults';
import styles from './index.sass';

class CategoryContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func,
    buildURLForRoute: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps(store, displayTitle) {
    let description = `${displayTitle} – ${store.name}`;
    let title = description;
    let { currentRoute } = this.props;
    return {
      title: title,
      meta: [
        {name: 'description', content: description},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {property: 'og:url', content: currentRoute.absolute_url},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description}
      ]
    };
  }

  handleOnClickBreadcrumbsFilter(filter) {
    // Remove it
    let filters = _.filter(this.props.inventorySearchState.filters, (f) => {
      return !_.isEqual(f, filter);
    });
    let { currentRoute } = this.props;

    trackSearchEvent(this.context, {
      filters: filters,
      pagination: this.props.inventorySearchState.pagination,
      sorter: this.props.inventorySearchState.sorter,
      uiMethod: 'delete_token'
    });

    this.context.executeAction(navigateAction, {
      url: this.context.buildURLForRoute(currentRoute.name, {
        type: currentRoute.params.type,
        filters: filters,
        sorter: this.props.inventorySearchState.sorter
      })
    });
  }

  render() {
    let { store, inventorySearchState, shoppingCart, currentRoute } = this.props;
    let currentPath = currentRoute.url.replace(/\?.*/, '');
    let navConfig = store.findTitleForCategoryURL(currentPath);

    let breadcrumbHelperText = null;
    let searchResultCount = inventorySearchState.pagination && inventorySearchState.pagination.hasOwnProperty('totalResults') ? inventorySearchState.pagination.totalResults : null;
    if(searchResultCount !== null) {
      if(!searchResultCount) {
        breadcrumbHelperText = 'No results';
      } else if(searchResultCount === 1) {
        breadcrumbHelperText = '1 result';
      } else {
        breadcrumbHelperText = `${searchResultCount} results`;
      }
    }
    let breadcrumbsProps = {
      className: styles.breadcrumbs,
      links: [{routeName: 'storeLandingPage'}],
      helperText: breadcrumbHelperText,
      onClickFilter: this.handleOnClickBreadcrumbsFilter.bind(this)
    };

    let chunks = currentPath.split('/');
    // Pop off the last chunk and use as fallback title
    let fallbackTitle = chunks.pop();
    // Use remaining to build breadcrumbs
    while(chunks.length > 1) {
      let url = chunks.join('/');
      let chunk = chunks.pop();
      if(chunk !== store.slug) {
        let text = toTitleCase(decodeURIComponent(chunk.replace(/-/g, ' ')));
        breadcrumbsProps.links.splice(1, 0, {text: text, href: url});
      }
    }

    if(inventorySearchState.filters.length) {
      // Filter out types to not be displayed as bubbles in breadcrumbs
      breadcrumbsProps.filters = _.filter(inventorySearchState.filters, (filter) => {
        if(_.find(currentRoute.params.filters, (f) => {return _.isEqual(f, filter);})) {return false;}
        switch(filter.type) {
          case 'text':
          case 'min_price_in_cents':
          case 'max_price_in_cents':
          case 'featured_on_banquet':
          case 'store_id':
            return false;
          default:
            return true;
        }
      });
    }

    let inventorySearchResultsProps = {
      currentRoute,
      store,
      ...inventorySearchState,
      loading: inventorySearchState.loading || !this.props.isNavigateComplete,
      title: navConfig ? navConfig.text : toTitleCase(decodeURIComponent(fallbackTitle.replace(/-/g, ' ')))
    };

    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(store, inventorySearchResultsProps.title)} />
        <Breadcrumbs {...breadcrumbsProps} />
        <InventorySearchResults {...inventorySearchResultsProps} />
      </section>
    );
  }
}

CategoryContainer = connectToStores(CategoryContainer, [InventoryRecordStore], (context, props) => {
  return {
    inventorySearchState: context.getStore(InventoryRecordStore).getCurrentSearchState()
  };
});

export default CategoryContainer;



// WEBPACK FOOTER //
// banquet/containers/CategoryContainer/index.js